import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Chip } from '@mui/material';

import { TaskStatus } from 'src/generated/mloop-graphql';

import { getColorForTaskStatus, getTaskStatusTranslationKey } from 'src/views-new/ScheduleTaskDashboard/utils';

type ScheduleTaskStatusProps = {
  status: TaskStatus;
  size?: 'small' | 'medium';
};

const ScheduleTaskStatus = ({ status, size }: ScheduleTaskStatusProps) => {
  const { t } = useTranslation();
  const label = t(getTaskStatusTranslationKey(status));
  const color = getColorForTaskStatus(status);

  return (
    <Chip
      data-testid={`schedule-task-status-${status}`}
      size={size}
      variant={
        color === 'info' ||
        status === TaskStatus.Canceled ||
        status === TaskStatus.ReadyToSendToCandidate ||
        status === TaskStatus.Completed
          ? 'filled'
          : 'outlined'
      }
      color={color}
      label={label}
    />
  );
};

export default ScheduleTaskStatus;
